import { useNavigate } from "react-router-dom"
import useHttpHandler from "../../../hooks/httpHandler";
import {useState, useEffect} from "react";
import {toast} from "react-toastify";

const useVehicle = () => {
    const navigate = useNavigate()
    const {get, deleteItem} = useHttpHandler()

    const [loading, setLoading] = useState(true)
    const [vehiclesList, setVehiclesList] = useState([])
    const [vehiclesMakeList, setVehiclesMakeList] = useState([])
    const [isConfirmDeleteModal, setIsConfirmDeleteModal] = useState(false);
    const [vehicleIDToDelete, setVehicleIDToDelete] = useState(null);
    const onOpenConfirmDeleteModal = (vehicleId) => {
        setVehicleIDToDelete(vehicleId)
        setIsConfirmDeleteModal(true);
    }
    const onClosConfirmDeleteModal = () => {
        setIsConfirmDeleteModal(false);
    }
    const gotoAddVehicleInformation = () => {
        navigate('/vehicle/add-vehicle-information')
    }
    const gotoEditVehicleInformation = () => {
        navigate('/vehicle/add-vehicle-information')
    }

    const getVehiclesList = () => {

        get('user/vehicles').then((res)=>{
            const data = res.data
            setVehiclesList(data.vehicles)
            setLoading(false)
        }).catch(err => {
            setLoading(false)
        })
    }

    const getVehiclesMakeList = () => {

        get('user/vehicles/makes').then((res)=>{
            const data = res.data
            setVehiclesMakeList(data.vehicle_makes)
            setLoading(false)
        }).catch(err => {
            setLoading(false)
        })
    }

    const deleteVehicleById = (vehicleId) => {
        setLoading(true)
        deleteItem('user/vehicles/'+vehicleId).then((res)=>{
            setLoading(false)

            toast.success('Vehicle deleted successfully')
            setVehicleIDToDelete(null)
            setIsConfirmDeleteModal(false);
            getVehiclesList()
        }).catch(err => {
            setLoading(false)
        })
    }

    useEffect(()=>{
        if(vehiclesList?.length >= 0) {
            getVehiclesList()
        }
        if(vehiclesMakeList?.length >= 0) {
            getVehiclesMakeList()
        }
    },[])


    
    return {
        loading,
        vehiclesList,
        gotoAddVehicleInformation,
        gotoEditVehicleInformation,
        getVehiclesList,
        deleteVehicleById,
        isConfirmDeleteModal,
        onOpenConfirmDeleteModal,
        onClosConfirmDeleteModal,
        vehicleIDToDelete,
        vehiclesMakeList
    }
}

export default useVehicle